import { render, staticRenderFns } from "./OperaArticleLabelsWindow.vue?vue&type=template&id=137a7c5a&scoped=true&"
import script from "./OperaArticleLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaArticleLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaArticleLabelsWindow.vue?vue&type=style&index=0&id=137a7c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a7c5a",
  null
  
)

export default component.exports